<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import { inlineStyle } from '../../lib/utils';
  import InlineSvg from './InlineSvg.svelte';

  export let sprite: string;
  export let steps: number;
  export let duration: string;
  export let icon = '';
  export let defaultIcon = '';
  export let active = false;
  export let size = 28;
  export let frameSize = 40;
  export let disabled = false;

  const dispatch = createEventDispatcher();
  let animating = false;

  $: frameDiff = frameSize - size;

  $: buttonStyle = inlineStyle({
    width: `${size}px`,
    height: `${size}px`,
  });

  $: innerStyle = inlineStyle({
    width: `${frameSize}px`,
    height: `${frameSize}px`,
    margin: `-${frameDiff / 2}px`,
    'background-image': `url(${sprite})`,
    'background-size': `${steps}00%`,
    'animation-duration': duration,
    'animation-timing-function': `steps(${steps - 1})`,
  });

  function onClick(evt: MouseEvent) {
    if (!active && !disabled) {
      animating = true;
    }

    dispatch('click', evt);
  }

  function onAnimationEnd() {
    animating = false;
  }
</script>

<button
  class="animation-button {$$props.class || ''}"
  style={buttonStyle}
  class:animating
  class:active
  class:has-icon={!!icon}
  on:click={onClick}
  on:animationend={onAnimationEnd}
>
  <span class="ab-inner" style={innerStyle} />
  {#if icon}
    <InlineSvg src={icon} />
  {:else}
    <InlineSvg src={defaultIcon} />
  {/if}
</button>

<style lang="scss">
  @import '../../styles/mixins';

  button {
    border: none;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--color-blue-gray--900);
    @include scale-on-active(0.9);

    &.animating {
      .ab-inner {
        animation: play;
        animation-iteration-count: 1;
        opacity: 1 !important;
      }

      :global(.svg-wrapper) {
        opacity: 0;
        visibility: visible;
      }
    }

    &.has-icon {
      .ab-inner {
        opacity: 0;
      }
    }

    &:hover,
    &.active {
      .ab-inner {
        background-position: right;
      }
    }
  }

  .ab-inner {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: block;
    background-position: left;
    background-repeat: no-repeat;
  }
  :not(.animating, .active) {
    .ab-inner {
      display: none;
    }
  }

  @keyframes play {
    from {
      background-position: left;
    }
    to {
      background-position: right;
    }
  }
</style>
